import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useParams, useLocation } from 'react-router-dom';

// components
import Header from '../../components/Header/Header';
import Navbar from '../../components/Navbar/Navbar';
import Breadcrumbs from '../../components/Breadcrumbs';

// icons
import leads from '../../brand/generated/sidebar/deals.svg';
import getDealItemsCount from '../../api/deals/getDealItemsCount';
import getDealCard from '../../api/deals/getDealCard';
import DealCreate from './DealCreate/DealCreate';
import getDealCars from '../../api/deals/getDealCars';
import getDealEquipments from '../../api/deals/getDealEquipments';
import getDealServices from '../../api/deals/getDealServices';
import getDealDocuments from '../../api/deals/getDealDocuments';
import Loader from '../../components/Loader/Loader';
import DealCreateSellEquipment from './DealCreate/SellEquipment/DealCreateSellEquipment';
import {
  DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION,
  DOCUMENT_TYPES_LOAN_APPROVAL_NOTIFICATION,
  DOCUMENT_TYPES_PAYMENT_ORDER,
  DOCUMENT_TYPES_GUARANTEE_LETTER,
  DOCUMENT_TYPES_PAYMENT_SCHEDULE,
  DOCUMENT_TYPES_TRIPARTITE_CONTRACT,
} from '../../constants';
import checkCrmSidebarNotifications from '../../api/notifications/checkCrmSidebarNotifications';

const DealNavigation = ({ to }) => {
  const { id } = useParams();
  const [equipmentsCount, setEquipmentsCount] = useState({});

  const { pathname } = useLocation();
  const [items, setItems] = useState(
    pathname != '/deals/create'
      ? [
          { text: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ', navigate: id ? `/deals/deal/${id}/main-info` : '/deals/create' },
          { text: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸', navigate: id ? `/deals/deal/${id}/autos` : '/deals/autos', count: 0 },
          {
            text: 'ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
            navigate: id ? `/deals/deal/${id}/equipments` : '/deals/equipments',
            count: 0,
            disabled: true,
          },
          {
            text: 'ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð¸',
            navigate: id ? `/deals/deal/${id}/services` : '/deals/services',
            count: 0,
            disabled: true,
          },
          { text: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ', navigate: id ? `/deals/deal/${id}/documents` : '/deals/documents', count: 0 },
          { text: 'ÐÐ°Ð½ÐºÐ¸', navigate: id ? `/deals/deal/${id}/credit` : '/deals/documents', count: 0, disabled: true },
          { text: 'ÐÑÑÐ¾ÑÐ¸Ñ', navigate: id ? `/deals/deal/${id}/history` : '/deals/history' },
        ]
      : [{ text: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ', navigate: id ? `/deals/deal/${id}/main-info` : '/deals/create' }]
  );

  // useEffect(() => {
  //   setItems(
  //     pathname != '/deals/create'
  //       ? [
  //           { text: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ', navigate: id ? `/deals/deal/${id}/main-info` : '/deals/create' },
  //           { text: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸', navigate: id ? `/deals/deal/${id}/autos` : '/deals/autos', count: 0 },
  //           { text: 'ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ', navigate: id ? `/deals/deal/${id}/equipments` : '/deals/equipments', count: 0, disabled: true },
  //           { text: 'ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð¸', navigate: id ? `/deals/deal/${id}/services` : '/deals/services', count: 0, disabled: true },
  //           { text: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ', navigate: id ? `/deals/deal/${id}/documents` : '/deals/documents', count: 0 },
  //           { text: 'ÐÐ°Ð½ÐºÐ¸', navigate: id ? `/deals/deal/${id}/credit` : '/deals/documents', count: 0, disabled: true  },
  //         ]
  //       : [{ text: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ', navigate: id ? `/deals/deal/${id}/main-info` : '/deals/create' }]
  //   );
  // }, [id]);

  const init = async () => {
    await getDealItemsCount({ id: id }).then((res) => {
      console.log(items);
      if (res.data) {
        const newItems =
          pathname != '/deals/create'
            ? [
                { text: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ', navigate: id ? `/deals/deal/${id}/main-info` : '/deals/create' },
                { text: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸', navigate: id ? `/deals/deal/${id}/autos` : '/deals/autos', count: 0 },
                {
                  text: 'ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
                  navigate: id ? `/deals/deal/${id}/equipments` : '/deals/equipments',
                  count: 0,
                  disabled: true,
                },
                {
                  text: 'ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð¸',
                  navigate: id ? `/deals/deal/${id}/services` : '/deals/services',
                  count: 0,
                  disabled: true,
                },
                { text: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ', navigate: id ? `/deals/deal/${id}/documents` : '/deals/documents', count: 0 },
                {
                  text: 'ÐÐ°Ð½ÐºÐ¸',
                  navigate: id ? `/deals/deal/${id}/credit` : '/deals/documents',
                  count: 0,
                  disabled: true,
                },
                { text: 'ÐÑÑÐ¾ÑÐ¸Ñ', navigate: id ? `/deals/deal/${id}/history` : '/deals/history' },
              ]
            : [{ text: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ', navigate: id ? `/deals/deal/${id}/main-info` : '/deals/create' }];
        newItems[1].count = res.data.cars;
        newItems[2].count = res.data.equipment;
        newItems[3].count = res.data.additionalService;
        newItems[4].count = res.data.document;
        newItems[5].count = res.data.banks;
        equipmentsCount.equipments = res.data.equipment;
        equipmentsCount.services = res.data.additionalService;
        setEquipmentsCount(equipmentsCount);

        if (res.data.cars > 0) {
          newItems[2].disabled = false;
          newItems[3].disabled = false;
          newItems[5].disabled = false;
        }

        setItems(newItems);
      }
    });
  };

  const [deal, setDeal] = useState(null);
  const [cars, setCars] = useState(null);
  const [equipments, setEquipments] = useState(null);
  const [services, setServices] = useState(null);
  const [documents, setDocuments] = useState(null);
  const [filteredDocuments, setFilteredDocuments] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);

  React.useEffect(() => {
    init();
    update();
  }, [id]);

  const update = async () => {
    setLoading(true);
    await getDealCard({ id }).then((res) => {
      setDeal(res?.data);

      if (res?.data?.notifications?.length > 0) {
        let ids = res?.data?.notifications?.map((item) => {
          return item.id;
        });
        checkCrmSidebarNotifications({ notificationIds: ids });
      }
    });
    await getDealCars({ id }).then((res) => {
      setCars(res?.data?.cars);
    });
    await getDealEquipments({ id }).then((res) => {
      setEquipments(
        res?.data?.map((item) => ({
          ...item,
          title: item?.name,
        }))
      );
    });
    await getDealServices({ id }).then((res) => {
      setServices(
        res?.data?.map((item) => ({
          ...item,
          title: item?.name,
        }))
      );
    });
    await getDealDocuments({ id }).then((res) => {
      setDocuments(res?.data);
    });
    setLoading(false);
    setLoadingPage(false);
  };

  useEffect(() => {
    if (!deal?.json) return;
    const alwaysAllowedDocuments = [
      DOCUMENT_TYPES_PAYMENT_ORDER,
      DOCUMENT_TYPES_LOAN_APPROVAL_NOTIFICATION,
      DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION,
      DOCUMENT_TYPES_GUARANTEE_LETTER,
      DOCUMENT_TYPES_TRIPARTITE_CONTRACT,
      // ÐÑÐ°ÑÐ¸Ðº Ð¿Ð»Ð°ÑÐµÐ¶ÐµÐ¹ Ð±Ð°Ð½ÐºÐ°: Ñ Jet Finance ÑÑÐ¾ ÐµÐ´Ð¸Ð½ÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ, ÐºÐ¾ÑÐ¾ÑÑÐ¹
      // Ð¼Ñ Ð¾Ñ Ð½ÐµÐ³Ð¾ Ð¿Ð¾Ð»ÑÑÐ°ÐµÐ¼, Ð³Ð°ÑÐ°Ð½ÑÐ¸Ð¹Ð½Ð¾Ð³Ð¾ Ð¿Ð¸ÑÑÐ¼Ð° Ð¾Ð½ Ð½Ðµ Ð²ÑÐ´Ð°ÑÑ.
      DOCUMENT_TYPES_PAYMENT_SCHEDULE,
    ];
    try {
      const allowedDocuments = JSON.parse(deal?.json)?.allowed_documents;

      const filteredDocuments = documents?.filter((item) => {
        return [...alwaysAllowedDocuments, ...allowedDocuments]?.includes(item?.type?.id);
      });

      setFilteredDocuments(filteredDocuments);
    } catch (e) {
      setFilteredDocuments(alwaysAllowedDocuments);
    }
  }, [deal, documents]);

  if (loadingPage) return <Loader />;

  if (deal?.only_dop && deal?.step != 10) {
    return (
      <DealCreateSellEquipment
        deal={deal}
        cars={cars}
        equipments={equipments}
        services={services}
        documents={documents}
        update={update}
        loading={loading}
        setLoading={setLoading}
      />
    );
  }

  if (deal?.step != 10) {
    return (
      <DealCreate
        deal={deal}
        cars={cars}
        equipments={equipments}
        services={services}
        documents={filteredDocuments}
        update={update}
        loading={loading}
        setLoading={setLoading}
      />
    );
  }

  return (
    <>
      <Header title={id ? `Ð¡Ð´ÐµÐ»ÐºÐ° ID ${id}` : 'ÐÐ¾Ð²Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ°'} icon={leads} />
      <Breadcrumbs navigate={'/deals'} link={'Ð¡Ð´ÐµÐ»ÐºÐ¸'} currentPage={id ? `Ð¡Ð´ÐµÐ»ÐºÐ° ID ${id}` : 'ÐÐ¾Ð²Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ°'} />
      <Navbar items={items} />
      <Outlet context={[equipmentsCount, init, deal]} />
    </>
  );
};

export default DealNavigation;
